<template>
    <div class="box">

        <div class="handle-box-search">


            <el-row type="flex" justify="center" style="margin-bottom: 20px;display:flex;align-items:center">

                <span style="display: inline-block;width: 80px;text-align: right; margin-right: 5px;">时间:</span>
                <el-date-picker v-model="search_time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
                                end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
                                style="width: 350px;">
                </el-date-picker>

            </el-row>

            <el-row type="flex" justify="center" style="margin-bottom: 20px;display:flex;align-items:center">

                <span style="display: inline-block;width: 80px;text-align: right; margin-right: 5px;">密码:</span>
                <el-input v-model="submit_data.export_password" style="width: 200px;" show-password></el-input>

            </el-row>

            <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...

            </div>

            <el-row type="flex" justify="center" v-else>

                <el-button type="primary" @click="toExport">导出订单信息</el-button>

            </el-row>



        </div>




    </div>

</template>

<script>
    import axios from 'axios';
    import { config } from '@/utils/config.js';
    import bus from '../../common/bus'; //配置
    var _this;
    export default {

        data() {
            return {
                search_time: '',

                submit_data: {
                    page: 1,
                    fixed_array: '',
                    export_password: '',
                },

                partnerList:[],

                excelData: [],

                excelHead: [],

                progress_show: false,
                progress_data: 0

            };
        },
        created() {
            _this = this;
            console.log(this.$route.path);


            bus.$on('btnStatus',(msg)=>{
                _this.progress_show = msg;
            });

        },

        methods: {
            timeChange(val) {
                if(val!=null){
                    _this.submit_data.fixed_array = JSON.stringify(['between'].concat(val));

                }else{
                    _this.submit_data.fixed_array = ''
                }

            },

            toExport() {

                _this.progress_show = true;
                _this.submit_data.page = 1;
                _this.getExcelData();

            },

            getExcelData() {

                _this.$post(
                    "/Inspectionline/exportOrderListsCsv",
                    _this.submit_data
                ).then(res => {



                    if (this.$route.path == '/inspectionLineOrderCSV') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {
                            console.log(res.data.list[i].order_code);
                            _this.excelData.push({
                                'amount': res.data.list[i].amount,
                                'consumer_name': res.data.list[i].consumer_name,
                                'consumer_phone': res.data.list[i].consumer_phone,
                                'driver_phone': res.data.list[i].driver_phone,
                                'driver_real_name': res.data.list[i].driver_real_name,
                                'inspection_order_code': res.data.list[i].inspection_order_code,
                                'inspection_line_name': res.data.list[i].inspection_line_name,
                                'start_name': res.data.list[i].start_name,
                                'finish_amount': res.data.list[i].finish_amount,
                                'end_time': res.data.list[i].end_time.YmdHis,
                                'admin_name': res.data.list[i].admin_name
                            });


                        }



                        if (res.data.page * res.data.limit < res.data.count) {

                            _this.submit_data.page = res.data.page + 1;

                            _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();

                        } else {

                            // console.log(_this.excelData);
                            console.log(111);
                            // 将数据导出execl
                            _this.exportData();

                            _this.submit_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;


                        }

                    } else {

                        _this.progress_show = false;
                        _this.progress_data = 0;

                    }



                }).catch((err) => {

                })

            },


            // 导出excel方法
            exportData() {
                console.log(111);
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['订单编码','检车线名称','乘客名', '手机号', '起点', '金额', '实付金额', '司机名称', '司机电话','管理员姓名',
                    '结束时间'];


                const filterVal = ['inspection_order_code','inspection_line_name','consumer_name','consumer_phone', 'start_name', 'amount',
                    'finish_amount','driver_real_name','driver_phone', 'admin_name', 'end_time'
                ];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, 'fileName');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },




        }
    };
</script>

<style scoped>

</style>
